"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StudentRepositoryStateType = void 0;
var StudentRepositoryStateType;
(function (StudentRepositoryStateType) {
    StudentRepositoryStateType[StudentRepositoryStateType["PENDING"] = 0] = "PENDING";
    StudentRepositoryStateType[StudentRepositoryStateType["ONLINE"] = 1] = "ONLINE";
    StudentRepositoryStateType[StudentRepositoryStateType["OFFLINE"] = 2] = "OFFLINE";
})(StudentRepositoryStateType = exports.StudentRepositoryStateType || (exports.StudentRepositoryStateType = {}));
